import React, { FC } from "react";

import { Title, Description, Meta } from "./DescriptionBlock.styled";

const DescriptionBlock: FC = () => (
  <>
    <Title as="h2">A Proudly South African Online Payment Gateway</Title>

    <Description as="p">
      Thank you for choosing <strong>Peach Payments.</strong> We look forward to
      partnering with you, your team and your business with our leading payments
      technology.
    </Description>

    <Meta as="p">The Peach Team</Meta>
  </>
);

export default DescriptionBlock;
